export default __webpack_public_path__ + "static/media/female_summer_olympics.c3460cfd.csv";